export default "__VITE_ASSET__$nwtQh8C__"